import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledWalletSavedCardsSection = styled.section`
  flex: 1 1 100%;
  width: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${toRem(24)};
  margin-bottom: ${toRem(32)};

  &:last-child {
    margin-bottom: 0;
  }

  @media ${baseVariables.mediaQuery.md} {
    flex: 1;
    min-width: 0;
  }

  .wallet-saved-cards-section__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${toRem(16)};
  }

  .wallet-saved-cards-section__title-wrapper {
    display: flex;
    align-items: center;
    gap: ${toRem(12)};
  }

  .wallet-saved-cards-section__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${toRem(24)};
    height: ${toRem(24)};
    font-size: ${toRem(16)};
    color: inherit;
    flex-shrink: 0;

    .icon-decorative {
      color: inherit;
    }
  }

  .wallet-saved-cards-section__title {
    font-size: ${toRem(18)};
    font-weight: 700;
    line-height: 1.25;
    color: ${baseVariables.color['base10']};
    margin: 0;
  }

  .wallet-saved-cards-section__badge {
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['neutral40']};
    white-space: nowrap;
  }

  .wallet-saved-cards-section__cards-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--general-spacer-04, ${toRem(24)});
    align-self: stretch;
    width: 100%;
  }

  .wallet-saved-card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${toRem(16)};
    width: 100%;
    align-self: stretch;
    padding-top: ${toRem(16)};
    padding-bottom: ${toRem(16)};
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .wallet-saved-cards-section__card-content {
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
    flex: 1;
    min-width: 0;
  }

  .wallet-saved-cards-section__card-thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${toRem(80)};
    height: ${toRem(56)};
    min-width: ${toRem(80)};
    background-color: ${baseVariables.color['neutral20']};
    border-radius: ${toRem(4)};
    font-size: ${toRem(12)};
    font-weight: 700;
    color: ${baseVariables.color['neutral40']};
    flex-shrink: 0;
    overflow: hidden;
  }

  .wallet-saved-cards-section__card-art {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${toRem(4)};
    display: block;
  }

  .wallet-saved-cards-section__card-info {
    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
    flex: 1;
    min-width: 0;
  }

  .wallet-saved-cards-section__card-number-wrapper {
    display: flex;
    align-items: center;
    gap: ${toRem(12)};

    /* Mobile: just the card number */
    flex-direction: row;

    @media ${baseVariables.mediaQuery.md} {
      flex-direction: row;
      align-items: center;
    }
  }

  .wallet-saved-cards-section__card-number {
    font-size: ${toRem(16)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['base10']};
    margin: 0;
  }

  .wallet-saved-cards-section__primary-badge {
    display: inline-flex;
    align-items: center;
    gap: ${toRem(4)};
    height: ${toRem(22)};
    padding: 0 ${toRem(8)};
    background-color: ${baseVariables.color['neutral20']};
    border-radius: ${toRem(4)};
    font-size: ${toRem(12)};
    font-weight: 700;
    line-height: 1.2;
    color: ${baseVariables.color['base10']};
    white-space: nowrap;
    width: fit-content;
    margin-top: ${toRem(4)};
  }

  .wallet-saved-cards-section__primary-badge svg {
    width: ${toRem(13.333)};
    height: ${toRem(12.667)};
    flex-shrink: 0;
  }

  .wallet-saved-cards-section__cardholder-name {
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['neutral40']};
    margin: 0;
  }

  .wallet-saved-cards-section__card-actions {
    display: flex;
    gap: ${toRem(8)};
    align-items: center;
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: ${toRem(28)};

    @media ${baseVariables.mediaQuery.md} {
      align-self: center;
      margin-top: 0;
    }
  }

  .wallet-saved-cards-section__action-button {
    flex-shrink: 0;
    margin: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['base10']};
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }

  .wallet-saved-cards-section__add-card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${toRem(16)};
  }

  .wallet-saved-cards-section__add-card-content {
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
    flex: 1;
  }

  .wallet-saved-cards-section__add-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${toRem(80)};
    height: ${toRem(56)};
    min-width: ${toRem(80)};
    border: ${toRem(1)} dashed ${baseVariables.color['neutral30']};
    border-radius: ${toRem(4)};
    font-size: ${toRem(24)};
    font-weight: 700;
    color: ${baseVariables.color['base10']};
    flex-shrink: 0;
  }

  .wallet-saved-cards-section__add-card-text {
    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
  }

  .wallet-saved-cards-section__add-card-title {
    font-size: ${toRem(18)};
    font-weight: 700;
    line-height: 1.25;
    color: ${baseVariables.color['base10']};
    margin: 0;
  }

  .wallet-saved-cards-section__add-card-subtitle {
    font-size: ${toRem(16)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['neutral40']};
    margin: 0;
  }

  .wallet-saved-cards-section__add-cta {
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['base10']};

    &:hover {
      text-decoration: underline;
    }
  }
`;
